import type { NavigationScreenSpaceState } from '@gitbook/app-navigation';
import { Icon } from '@gitbook/spine-icons';
import { Button, type ButtonProps } from '@gitbook/spine-react';

/**
 * Button to open the variables side-panel.
 */
export function VariablesSidePanelButton(
    props: {
        screen: NavigationScreenSpaceState;
    } & Omit<ButtonProps, 'onPress' | 'label'>
) {
    const { screen, style, ...rest } = props;

    return (
        <Button
            kind="blank"
            size="medium"
            {...rest}
            href={{
                screen: {
                    sideSheet:
                        screen.sideSheet?.type === 'variables'
                            ? undefined
                            : {
                                  type: 'variables',
                                  tab: 'space',
                              },
                },
            }}
            leadingIcon={Icon.Variable}
            iconOnly
            style={style}
            active={screen.sideSheet?.type === 'variables'}
            label="Edit and reuse variables"
        />
    );
}
